module.exports = __webpack_public_path__ + "img/alumni-image.3e892fa3.webp";